var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.subclientDetail)?_c('div',[_c('subclient-editable-detail',{attrs:{"detail":_vm.subclientDetail},on:{"fetch-subclient-required":_vm.handleFetchSubclientRequired}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }